// this is the base class for all channel data.
import { TeamDataObject } from "../DataStorage/TeamDataObject";

export abstract class ChannelDataObject extends TeamDataObject {
    abstract readonly channelDataType?: string;

    datePosted?: Date;
    whoPosted?: string;

    channelName?: string;
    parentId?: string;

    replyCount?: number = 0;
    lastReplyDate?: Date;
}
